import PublishIcon from "@mui/icons-material/Publish";
import { Button, Tooltip } from "@mui/material";

/**
 * Ingests the run. For a pair nobody has approved yet the same click approves
 * it, and the label says so only when the click is possible: a disabled button
 * reads plain "Ingest" with the reason in its tooltip.
 */
export function IngestPipelineButton({
  onClick,
  disabledReason,
  needsApproval,
}: {
  onClick: () => void;
  /** Why ingesting is not possible right now; undefined when it is. */
  disabledReason: string | undefined;
  needsApproval: boolean;
}) {
  const disabled = disabledReason !== undefined;
  return (
    <Tooltip title={disabledReason ?? ""}>
      <span>
        <Button
          variant="contained"
          startIcon={<PublishIcon />}
          onClick={onClick}
          disabled={disabled}
          // Sits in the flex header row; keep the label on one line when the title is long.
          sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
        >
          {needsApproval && !disabled ? "Approve & Ingest" : "Ingest Pipeline"}
        </Button>
      </span>
    </Tooltip>
  );
}
